import React, { useEffect } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import Main from './components/Main/Main';
import User from './components/User/User';
import ServerError from './components/Errors/ServerError/ServerError';
import { useDispatch, useSelector } from 'react-redux';
import { changeTranslationMode } from './store/actions/settings';

const AuthRoute = ({ component: Component, authUser, ...rest }) => {
    return (
        <Route
            {...rest}
            render={props =>
                authUser ? (
                    <Component {...props} />
                ) : (
                    <Redirect to={{ pathname: '/user/login', state: { from: props.location } }} />
                )
            }
        />
    );
};

const Routes = () => {
    const dispatch = useDispatch();
    const location = useLocation();

    const { isAuth } = useSelector(state => state.auth);

    useEffect(() => {
        const isTranslationMode = location.search.includes('translation-mode=on');

        if (isTranslationMode) {
            dispatch(changeTranslationMode(isTranslationMode));
        }
    }, []);

    return (
        <Switch>
            <Redirect exact from={'/'} to={'/app'} />
            <AuthRoute path='/app' authUser={isAuth} component={Main} />
            <Route path='/user' component={User} />
            <Route path='/500' component={ServerError} />
        </Switch>
    );
};

export default Routes;
